import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useDispatch } from "react-redux";

import { useTheme } from "@mui/material/styles";
import Hl7JobsTable from "./Components/Hl7JobsTable";

import JobTabs from "./Components/JobTabs";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";

const JobTabComponentMapping = ({ alertType, setAlertType }) => ({
  hl7jobs: <Hl7JobsTable alertType={alertType} setAlertType={setAlertType} />,
});

export function EHRJobs() {
  const { pathname } = useLocation();
  const selectedTab = pathname.split("/").pop().toLowerCase() || "hl7jobs";
  const [alertType, setAlertType] = useState("All");

  const role = localStorage.getItem("userRole");
  const theme = useTheme();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setTitle({
        title: "EHR Jobs",
      })
    );
  }, []);

  const tabStyles = (currentTab, isDisplayed) => {
    return {
      border: selectedTab === currentTab ? "1px solid #E0E0E0" : "none",
      borderBottom:
        selectedTab === currentTab ? theme.palette.background.paper : "none",
      display: isDisplayed ? "block" : "none",
      backgroundColor:
        selectedTab === currentTab
          ? theme.palette.background.paper
          : "transparent",
    };
  };

  // if (activeEHRJobsTab && activeEHRJobsTab !== selectedTab) {
  //   return <Navigate to={`/ehr-jobs/${activeEHRJobsTab}`} />;
  // }

  const jobTabComponentMapping = JobTabComponentMapping({
    alertType,
    setAlertType,
  });

  return (
    <>
      <JobTabs selectedTab={selectedTab} role={role} tabStyles={tabStyles} />
      {jobTabComponentMapping[selectedTab]}
    </>
  );
}
